import React from 'react';
import TextFieldProto from './text-proto.jsx';


export default function renderStringInList(id, props) {
    return <TextFieldProto renderMode="list" id={id} {...props} />;
}